import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id F80F249A-898B-4690-888A-EC11F79B4E56
 * name text-short
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-short.svg
 * tags
 */
export const TextShortIcon = createSvgIcon(<><path d="M4,9H20V11H4V9M4,13H14V15H4V13Z" /></>, 'TextShortIcon');
export default TextShortIcon